var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1175 14.1257C25.5477 16.3273 24.1053 18.4529 21.9037 18.8831C19.7021 19.3133 17.5764 17.8709 17.1462 15.6693C16.716 13.4677 18.1584 11.342 20.36 10.9118C22.5616 10.4816 24.6873 11.9241 25.1175 14.1257Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53906 21.4988C8.03125 17.8295 20.4057 18.1585 25.1379 22.9412C27.795 25.5984 25.7959 32.3297 23.1388 37.1884C21.5698 40.0479 19.7984 42.2495 18.6343 42.5785C22.0759 35.4929 21.7723 15.6532 4.53906 21.5241V21.4988Z",
    fill: "url(#paint0_linear_8287_172496)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9844 20.8684C28.679 19.1729 30.7288 11.9608 30.7794 9C33.0569 15.8832 30.3492 28.7638 26.0472 34.5841C27.5656 30.8641 29.2104 24.7402 26.0472 21.6529C25.7435 21.3492 25.364 21.0961 24.9844 20.8684Z",
    fill: "#E8E8E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6343 42.5893C29.3893 27.0516 17.6474 15.5881 4.53906 21.5349C20.9625 16.7774 22.0759 35.529 18.6343 42.5893Z",
    fill: "#F5E003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7836 9C31.5934 15.0734 29.822 18.4643 28 21.1214C29.1388 22.8422 29.4424 25.5246 29.2147 28.283C31.4669 21.9818 32.4032 13.9346 30.7836 9Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.134 18.8216C18.894 18.3155 17.9324 17.2274 17.654 15.8103C17.2238 13.6087 18.6663 11.5083 20.8679 11.0781C21.5258 10.9516 22.1584 11.0022 22.7658 11.1793C23.9552 11.7107 24.8409 12.7736 25.1192 14.1401C25.5494 16.3417 24.107 18.4674 21.9054 18.8976C21.298 19.0241 20.716 18.9988 20.1593 18.847L20.134 18.8216Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5657 4.64725C31.4392 5.38112 31.2874 6.14029 31.1608 6.87415L28.3519 8.36719L29.44 5.38111L26.707 3.71094L31.5404 4.62194L31.5657 4.64725Z",
    fill: "url(#paint1_linear_8287_172496)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3731 5.57507L33.2605 6.13179L33.1846 9.32031L31.1602 6.89097C31.2867 6.1571 31.4385 5.39793 31.565 4.66406L36.3731 5.57507Z",
    fill: "url(#paint2_linear_8287_172496)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9688 2.42935C31.8422 3.16322 31.6904 3.92239 31.5639 4.65625L26.7305 3.74525L29.8431 3.18852L29.919 0L31.9434 2.42935H31.9688Z",
    fill: "url(#paint3_linear_8287_172496)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6902 3.91389L36.4232 5.58407H36.3979L31.5898 4.67307C31.7164 3.9392 31.8682 3.18003 31.9947 2.44616L34.8037 0.953125L33.7155 3.9392L33.6902 3.91389Z",
    fill: "url(#paint4_linear_8287_172496)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37.6596L39.1143 38.7478C31.3961 48.3639 17.1742 49.8317 7.76051 41.8604C4.57199 39.1527 2.16795 35.5339 0.953272 31.5356C-2.38708 20.6036 3.3067 8.98825 14.0363 4.98995C17.5538 3.69935 21.4003 3.34507 25.0949 3.97772C21.4256 3.42099 17.5791 3.82588 14.1122 5.19239C3.38262 9.41845 -2.0075 21.4387 2.09203 32.2695C5.10341 40.2155 12.8217 45.6309 21.3244 45.6562C24.0321 45.6562 26.7398 45.1501 29.2451 44.1379C32.5854 42.7967 35.5209 40.5192 37.7225 37.6849H40V37.6596Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8287_172496",
    x1: 23.6196,
    y1: 22.587,
    x2: 15.0156,
    y2: 29.3942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#DFB82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E9C91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EFD316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D714"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8287_172496",
    x1: 27.2791,
    y1: 7.67132,
    x2: 30.0901,
    y2: 3.63144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DFB82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E9C91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EFD316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F2D714"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8287_172496",
    x1: 31.7411,
    y1: 8.33556,
    x2: 34.5319,
    y2: 4.31099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DFB82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E9C91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EFD316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F2D714"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8287_172496",
    x1: 28.5626,
    y1: 5.02083,
    x2: 31.3535,
    y2: 0.996258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DFB82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E9C91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EFD316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F2D714"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8287_172496",
    x1: 33.026,
    y1: 5.65977,
    x2: 35.8015,
    y2: 1.61504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D2A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DFB82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E9C91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EFD316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F2D714"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLogo);
export default __webpack_public_path__ + "static/media/ShortLogo.e86a10d1027a1126e67528fd83f888f8.svg";
export { ForwardRef as ReactComponent };